module.exports = __webpack_public_path__ + "static/img/shareLogo.b55aa6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shareLogo.png
// module id = HGed
// module chunks = 27